export const PARTNERSHIPS_PERMISSIONS = {
    partnerships: 'partnerships',
    mobees: 'mobees',
    trakto: 'trakto',
};

export const PARTNERSHIPS_ROUTERS = {
    MOBEES: '/partnerships/mobees',
    TRAKTO: '/partnerships/trakto',
};
